export class UserBlog {
  approved = false
  link = ''
}
